/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TenantEmailSettingsDto } from './TenantEmailSettingsDto';
import {
    instanceOfTenantEmailSettingsDto,
    TenantEmailSettingsDtoFromJSON,
    TenantEmailSettingsDtoFromJSONTyped,
    TenantEmailSettingsDtoToJSON,
} from './TenantEmailSettingsDto';

/**
 * @type InstallationConfigDtoEmailSettings
 * 
 * @export
 */
export type InstallationConfigDtoEmailSettings = TenantEmailSettingsDto;


export function InstallationConfigDtoEmailSettingsFromJSON(json: any): InstallationConfigDtoEmailSettings {
    return InstallationConfigDtoEmailSettingsFromJSONTyped(json, false);
}

export function InstallationConfigDtoEmailSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstallationConfigDtoEmailSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...TenantEmailSettingsDtoFromJSONTyped(json, true) };
    return  TenantEmailSettingsDtoFromJSONTyped(json, true);
}

export function InstallationConfigDtoEmailSettingsToJSON(value?: InstallationConfigDtoEmailSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfTenantEmailSettingsDto(value)) {
        return TenantEmailSettingsDtoToJSON(value as TenantEmailSettingsDto);
    }

    return {};
}

/**
 * Check if a given object implements the InstallationConfigDtoEmailSettings interface.
 */
export function instanceOfInstallationConfigDtoEmailSettings(value: any): value is InstallationConfigDtoEmailSettings {
    if (instanceOfTenantEmailSettingsDto(value)) return true;
    return false;
}

